/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { MockConnection, MockBackend } from './public_api';
//# sourceMappingURL=testing.js.map